import types from 'actions/types'
import {isNil} from 'lodash'
import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'

export const isVisible = (state = false, action) => {
    switch (action.type) {
        case types.SHOW_OPPORTUNITY_DIALOG:
            return true
        case types.HIDE_OPPORTUNITY_DIALOG:
            return false
        default:
            return state
    }
}

export const isLoading = (state = false, action) => {
    switch (action.type) {
        case types.OPPORTUNITY_LOAD_ATTEMPT:
            return true
        case types.OPPORTUNITY_LOAD_SUCCESS:
            return false
        case types.OPPORTUNITY_LOAD_FAILURE:
            return false
        case types.OPPORTUNITY_ADD_ATTEMPT:
            return true
        case types.OPPORTUNITY_ADD_SUCCESS:
            return false
        case types.OPPORTUNITY_ADD_FAILURE:
            return false
        case types.OPPORTUNITY_UPDATE_ATTEMPT:
            return true
        case types.OPPORTUNITY_UPDATE_SUCCESS:
            return false
        case types.OPPORTUNITY_UPDATE_FAILURE:
            return false
        default:
            return state
    }
}

export const isAdding = (state = false, action) => {
    switch (action.type) {
        case types.SHOW_OPPORTUNITY_DIALOG:
            return action.isAdding
        case types.HIDE_OPPORTUNITY_DIALOG:
            return false
        case types.OPPORTUNITY_ADD_SUCCESS:
            return false
        case types.OPPORTUNITY_UPDATE_SUCCESS:
            return false
        default:
            return state
    }
}

export const opportunity = (state = null, action) => {
    switch (action.type) {
        case types.SHOW_OPPORTUNITY_DIALOG:
            return action.isAdding
                ? null
                : state
        case types.OPPORTUNITY_LOAD_SUCCESS:
            return action.data
        case types.OPPORTUNITY_ADD_SUCCESS:
            return action.data
        case types.OPPORTUNITY_UPDATE_SUCCESS:
            return action.data
        case types.CONTACTS_CONTACT_EDIT_SUCCESS:
            const updatedContact = action.data
            if (!isNil(state) && updatedContact.id === state.contactId) {
                return {
                    ...state,
                    contact: {
                        ...state.contact,
                        ...updatedContact,
                    },
                }
            }
            return state
        default:
            return state
    }
}

export const opportunityDialogActivitiesPivotTableKey = 'dialogs.opportunity.activities'
export const opportunityDialogQuotesPivotTableKey = 'dialogs.opportunity.quotes'

export default combineReducers({
    isVisible,
    isLoading,
    isAdding,
    opportunity,
    activities: createPivotTableReducer({key: opportunityDialogActivitiesPivotTableKey, defaultSortColumn: 'startDate'}),
    quotes: createPivotTableReducer({key: opportunityDialogQuotesPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
})
